<template>
  <button
    :class="[
      'tab',
      active ? 'active' : '',
    ]"
    @click="$emit('select')"
  >
    <svg-vue
      v-if="icon"
      :icon="icon"
      class="svg_icon"
    />
    <span>
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    }
  },
  emits: ['select'],
}
</script>

<style lang="scss" scoped>
button {
  &.tab {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: .5rem 1rem;
    background-color: rgba(0, 0, 0, .05);
    border-radius: 0.75rem;
    transition: .3s;
    font-size: 1rem;
    line-height: 1.625;
    letter-spacing: -0.015625em;
    color: #4E4E54;

    &.active, &:hover {
      background-color: #DFF5EE;
      color: #0A8080;

      > .svg_icon {
        height: 24px;
        width: 24px;

        :deep(path) {
          stroke: #0A8080;
        }

        :deep(path.stroke) {
          fill: #0A8080;
        }
      }
    }

    > .svg_icon {
      height: 24px;
      width: 24px;
      margin-right: .5rem;
      transition: .3s;

      :deep(path) {
        transition: .3s;
        stroke: #4E4E54;
      }

      :deep(path.stroke) {
        fill: #4E4E54;
      }
    }

    &:not(:last-of-type) {
      margin-right: 1rem;
    }
  }
}
</style>
